import {AllRegister} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/poly/registers/AllMini';

export class EngineMiniAllRegister {
	private static _started = false;
	static run() {
		if (this._started) {
			return;
		}
		this._started = true;
		AllRegister.run();
	}
}
